import { useEffect, useState } from "react";
import HeaderSection from "../../components/HeaderSection";
import RowTeams from "../../components/rows/row-teams";
import { getTeam_Leader } from "../../http";
import { useSelector } from "react-redux";

const Members = () => {
  const [users, setUsers] = useState();
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => state.authSlice);
  const leaderId = user.id;
  useEffect(() => {
    (async () => {
      const res = await getTeam_Leader(leaderId);

      if (res.data.success) {
        setUsers(res.data.data);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <div className="main-content">
        <section className="section">
          <HeaderSection title="All Teams" />
          <div className="card">
            <div className="card-header">
              <h4>All Teams</h4>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped table-md center-text">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Created At</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading &&
                      users &&
                      users.map((data, index) => {
                        return (
                          <RowTeams key={index} index={index + 1} data={data} />
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Members;
